document.addEventListener("DOMContentLoaded", function() {
  var cookieAccessToken = getCookie("access_token");
  var uri = window.location.href;
  var path = location.href.replace(/.*\/\/[^\/]*/, '');
  var pathname = path;
  var pathParams = '';
  if(path.indexOf('?') > -1) {
    pathname = path.split('?')[0];
    pathParams = path.substr(path.indexOf('?'));
  }
  var params = loadParams(uri);
  if (cookieAccessToken || uri.indexOf("password") != -1|| params["uuid"] ) {

    // prevent access password_edit without logged-in or token
    if (uri.indexOf('password_edit') != -1 && !params['token']) {
      location.href = '/lp/index.html';
      return;
    }
    loadMainJS(params);
  } else {
    var querys = uri.indexOf('?') != -1 ? uri.slice(uri.indexOf('?')) : '';
    var date1 = new Date();
    var isLogout = localStorage.getItem('logout');
    date1.setTime(0);
    document.cookie = `access_token=;expires=${date1.toGMTString()}`;
    document.cookie = `society_${process.env.NODE_ENV}_access_token=;expires=${date1.toGMTString()}`;
    if (pathname === "/" || pathname === "/#/" || pathname === "/#/user" || isLogout) {
      location.href = "/lp/index.html" + pathParams;
      localStorage.clear();
    } else if(pathname === '/#/login' || pathname === '/login') {
      location.href = "/lp/index.html?login";
    } else {
      sessionStorage.setItem('reservationPath', pathname);
      location.href = "/lp/access-denied.html";
    }
  }
});

function loadParams(uri) {
  var vars = [];
  var hash;
  var hashes = uri.slice(uri.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = decodeURI(hash[1]);
  }
  return vars;
}

function loadMainJS(){
  var scripts = ['/lib/app.js?d=' + __BUILD_DATE__, '/bower_components/modernizr/modernizr.js'];
  var len = scripts.length;
  var i = 0;

  (function appendScript() {
    var script = document.createElement('script');
    script.src = scripts[i];
    document.body.appendChild(script);
    if (i < len - 1) {
      i++;
      script.onload = appendScript;
    }
  })();
}

//クッキー取得
function getCookie( name ){
  var result = [];
  var cookies = document.cookie;
  if(cookies != ''){
    var cookiesAry = cookies.split(';');
    for(var i = 0; i < cookiesAry.length; i++){
      var cookie = cookiesAry[i].trim().split('=');
      result[cookie[0]] = decodeURIComponent(cookie[1]);
    }
  }
  return result[name]
}



/** WEBPACK FOOTER **
 ** ./static/scripts/starter.js
 **/